import { useParams, Link } from "react-router-dom";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: `We are a youth-focused platform (ages 13–21). We collect only what's needed to help you find jobs safely.

- We NEVER sell your data.
- Personal contact info (phone, address) is hidden from public view.
- Employers only see your name, email, and profile info AFTER you apply.
- Youth under 13 are not permitted on the platform.
- Youth 13–17 accounts require parental/guardian awareness. See our Safety page.
- You may request deletion of your account and data at any time by contacting support.`,
  },
  terms: {
    title: "Terms of Service",
    body: `By using NextHire you agree to be honest in your profile, respectful in the community, and never post scams or harmful content. We reserve the right to remove content or accounts that violate our Community Guidelines.`,
  },
  safety: {
    title: "Youth Safety Policy",
    body: `Your safety is our first priority.

RULES WE FOLLOW:
- Every job is age-tagged. You see only what you can legally hold.
- Employers must agree to youth safety standards.
- Public posts are moderated by humans.
- Personal contact info is hidden on public profiles.

RULES FOR YOU:
- Never share your phone number, home address, or bank info in the community.
- Never pay to get a job. NextHire is FREE for youth.
- If someone messages you off-platform asking for personal info — REPORT them.
- Under 18? Talk to a parent/guardian before your first interview.
- Meet interviewers in public places or on approved video calls.`,
  },
  employers: {
    title: "Employer Guidelines",
    body: `Employers on NextHire agree to:
- Verify age-appropriateness of every role.
- Comply with all local labor laws (work permits, hours, wages).
- Never ask youth for payment, bank details, or SSN outside a proper hiring process.
- Communicate professionally through the platform.
- Respond to applicants within 14 days.

Violations may result in immediate account suspension.`,
  },
  community: {
    title: "Community Guidelines",
    body: `The NextHire community is a safe space for youth to share job experiences. Please:
- Be kind. Different backgrounds welcome.
- No harassment, hate, or targeting.
- Never share other people's contact info.
- No spam, scams, or off-platform recruiting.
- Report anything sketchy. Our team responds fast.`,
  },
  scams: {
    title: "Scam Warnings & Job Safety Tips",
    body: `RED FLAGS FOR JOB SCAMS:
- "Pay $50 for training material" → SCAM.
- "We'll send you a check to deposit" → SCAM.
- "Send me your SSN before the interview" → SCAM.
- Offers that seem too good ($100/hr for no work) → SCAM.
- Messages that push you off NextHire to Telegram/WhatsApp → SUSPICIOUS.

REAL JOBS:
- Never ask you to pay.
- Have a real business address.
- Interview you before hiring.
- Pay you AFTER work, on a real schedule.

When in doubt: TELL A TRUSTED ADULT. Report it here.`,
  },
  contact: {
    title: "Contact Us",
    body: `We're a small team building for youth. Reach us:

Email: hello@nexthire.example
Support: support@nexthire.example
Safety concerns: safety@nexthire.example (24hr response)

If you're a parent/guardian with questions about your teen's account, we're here to help.`,
  },
  resources: {
    title: "Youth Resources",
    body: `HELPFUL LINKS FOR YOUNG JOB SEEKERS:
- Youth work permits (US Dept of Labor): dol.gov/general/topic/youthlabor
- Age-restriction rules by state: youthrules.gov
- Money management for teens: consumer.gov
- Free resume review from your school counselor

You've got this.`,
  },
};

export default function Legal() {
  const { page } = useParams();
  const c = CONTENT[page] || CONTENT.safety;
  return (
    <div className="nh-container py-14 grid md:grid-cols-4 gap-8">
      <aside className="nh-card p-5 h-fit sticky top-24">
        <h3 className="font-display font-black text-lg">Legal & Safety</h3>
        <ul className="mt-3 space-y-2 text-sm">
          {Object.keys(CONTENT).map(k=>(
            <li key={k}>
              <Link to={`/legal/${k}`} className={`hover:underline ${k===page ? "font-bold underline" : ""}`}>
                {CONTENT[k].title}
              </Link>
            </li>
          ))}
        </ul>
      </aside>
      <article className="md:col-span-3 nh-card p-8">
        <h1 className="font-display font-black text-4xl">{c.title}</h1>
        <div className="prose-nh mt-4 whitespace-pre-line text-[var(--nh-muted)]">{c.body}</div>
      </article>
    </div>
  );
}
